import React, { Component, Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authActions, alertActions, AppVersionActions } from '../../store/actions';
import { history } from '../../helpers/history';
import Footer from '../../components/Footer/footer';
import { validationEmail } from '../../helpers/response';

import { PatientDesiredRole, enableGA } from '../../config';

import defaultImage from '../../static/images/saayalogo.svg';
import '../../static/css/styles.css';
import '../../components/Modal/modal.css';
import Loading from '../../components/Loading/Loading';
import { constants } from '../../Constants';
import { Counsellor_Portal_URL } from '../../config';
import ReactGA from 'react-ga';

const Image = lazy(() => import('../../components/Image/index'));
class LogIn extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_domain: '@khi.iba.edu.pk',
			email_address: '',
			password: '',
			submitted: false,
			desiredRole: PatientDesiredRole,
			showModal: false,
			modalClosed: false,
			loading: true,
			is_mobile: false,
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleRadioButton = this.handleRadioButton.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}

	componentWillMount() {
		//if (window.location.hostname.indexOf(Sub_Domain) > -1) history.push('/login/counsellor');
		this.props.appVersion();
		const user = JSON.parse(localStorage.getItem('user'));
		if (user === null) {
		} else {
			if (user.role === 0) {
				history.push('/home/counsellor');
			}
			if (user.role === 1) {
				history.push('/home');
			}
		}
	}

	componentDidMount() {
		ReactGA.initialize(process.env.REACT_APP_GA_TOKEN);
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
		// ReactGA.event({Category: 'PRODUCT', Action:'Product added to cart', Label:'PRODUCT_PAGE' });

		// on Boarding
		const urlLink = window.location.href.toString().includes(constants.EMAIL);
		if (urlLink) {
			const onboardingLoginEmail = window.location.pathname.split('=')[1];

			if (validationEmail(onboardingLoginEmail)) {
				this.props.getOnBoardingStatus(onboardingLoginEmail);
				this.setState({
					email_address: onboardingLoginEmail,
					isApiCalled: true,
				});
			}
		} else {
			this.setState({
				showModal: false,
				isApiCalled: false,
				modalClosed: true,
				loading: false,
			});
		}

		// clear alert on location change
		this.props.clearAlertActions();
	}

	componentWillReceiveProps(nextProps) {
		// on Boarding
		// if (nextProps.whitelabel) {
		// 	const { modalClosed } = this.state;
		// 	const subDomain = nextProps.whitelabel[0].sub_domain.toLowerCase();
		// 	if (subDomain.indexOf(constants.PAKQATAR.toLowerCase()) > -1) {
		// 		if (
		// 			nextProps.authstate.response &&
		// 			nextProps.authstate.response.is_verified !== null &&
		// 			nextProps.authstate.response.is_verified !== undefined
		// 		) {
		// 			if (!modalClosed) {
		// 				if (!nextProps.authstate.response.is_verified) {
		// 					this.setState({
		// 						loading: false,
		// 						showModal: true,
		// 						isApiCalled: false,
		// 						modalClosed: false,
		// 					});
		// 				} else {
		// 					this.setState({
		// 						loading: false,
		// 						showModal: false,
		// 						isApiCalled: false,
		// 					});
		// 				}
		// 			} else {
		// 				this.setState({
		// 					loading: false,
		// 					showModal: false,
		// 					isApiCalled: false,
		// 				});
		// 			}
		// 		}
		// 	} else {
		// 		this.setState({
		// 			email_address: '',
		// 			loading: false,
		// 			showModal: false,
		// 			isApiCalled: false,
		// 		});
		// 	}
		// }
	}

	handleRadioButton(e) {
		this.setState({ email_domain: e.target.value });
	}

	forgotPassword = () => {
		history.push('/emailverification');
	};

	register = () => {
		history.push('/registration');
	};

	counsellorLogIn = () => {
		history.push('/login/counsellor');
	};

	handleChange(e) {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	}

	parseEmailDomains() {}

	getUserEmailDomain() {
		const { email_address } = this.state;
		if (validationEmail(email_address)) {
			var email_domain = email_address.split('@')[1];
			return email_domain;
		}
	}

	validateEmail() {
		var userInput = this.getUserEmailDomain();
		var parsedEmails = []; //this.parseEmailDomains();
		for (var i = 0; i < parsedEmails.length; i++) {
			if (userInput === parsedEmails[i] || parsedEmails[i] === 'all') {
				return true;
			}
		}
		return false;
	}

	handleSubmit(ev) {
		ev.preventDefault();
		const { email_address, password } = this.state;
		if (!validationEmail(email_address)) {
			const message = constants.EMAIL_VALIDATION_MSG;
			this.props.alertError(message);
		} else if (email_address && password) {
			this.props.clearAlertActions();
			this.props.loginAuthentication(email_address, password);
		} else {
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		}
	}

	closeModal = () => {
		// on Boarding
		this.setState({ showModal: false });
	};

	render() {
		const { alert } = this.props;
		if (enableGA)
			ReactGA.event({
				category: 'Landing',
				action: 'Login',
				label: 'Admin',
				transport: 'beacon',
			});
		return this.state.loading ? (
			<Loading />
		) : (
			<React.Fragment>
				{/* on Boarding Starts */}

				{!this.state.is_mobile ? (
					<div className="ContainerFix">
						<div className="container containerFlex">
							<div className="row my-3">
								<div className="card borderless w-100 col-sm-9 col-md-7 col-lg-5 mx-auto my-2">
									<div className="card-signin my-5">
										<div className="card-body mt-6 ml-4 mr-4">
											{
												<Suspense
													fallback={
														<div className="logo">
															<div
																className="loader-wrapper"
																style={{ position: 'inherit' }}
															>
																<div className="loader"></div>
															</div>
														</div>
													}
												>
													<section>
														<Image src={defaultImage} alt="SaayaHealth logo" />
													</section>
												</Suspense>
											}
											<h5 className="card-title text-center mt-5 login-card-title">
												{constants.SIGN_IN_SESSION}
											</h5>
											{alert.message && (
												<div className={`alert text-center ${alert.type}`} id="errorMessage">
													{alert.message}
												</div>
											)}
											<form className="form-signin">
												<div className="mb-1 register-radios" />
												<div className="form-label-group mt-2 mb-3">
													<input
														type="email"
														id="inputEmail"
														className="form-control login-styling"
														placeholder={constants.EMAIL_ADDRESS}
														value={this.state.email_address || ''}
														name="email_address"
														onChange={this.handleChange}
														required
														aria-describedby="basic-addon2"
													/>
													<label htmlFor="inputEmail">
														{constants.ENTER_YOU_EMAIL.replace('{0}', '')}
													</label>

													<div className="input-icons">
														<i className="fas fa-envelope" />
													</div>
												</div>

												<div className="form-label-group mt-4">
													<input
														type="password"
														id="inputPassword"
														className="form-control login-styling"
														placeholder="Password"
														name="password"
														autoComplete="off"
														onChange={this.handleChange}
														required
													/>
													<label htmlFor="inputPassword">{constants.PASSWORD}</label>
													<div className="input-icons">
														<i className="fas fa-lock" />
													</div>
												</div>

												<button
													className="btn btn-lg btn-primary btn-block mt-4 mb-0 custom-btn"
													onClick={this.handleSubmit}
													type="submit"
												>
													{constants.SIGN_IN}
												</button>
												
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					// FOR DEVICES LESS THAN 700 WIDTH
					<div className="ContainerFix MobileContainerFix">
						<div className="container containerFlex">
							<div className="row">
								<div className="card borderless w-100 col-sm-9 col-md-7 col-lg-5 mx-auto my-2 MobileContainerFix">
									<div className="card-body mt-6 ml-4 mr-4">
										{
											<Suspense
												fallback={
													<div className="logo">
														<div className="loader-wrapper" style={{ position: 'inherit' }}>
															<div className="loader"></div>
														</div>
													</div>
												}
											>
												<section>
													<Image src={defaultImage} alt="SaayaHealth logo" />
												</section>
											</Suspense>
										}
										<h5 className="mobile-card-title text-center mt-5 login-card-title">
											{constants.MOBILE_SIGN_IN_SESSION}
										</h5>
										<form className="form-signin" autoComplete="off">
											<div className="mb-1 register-radios" />
											<div className="mobile-form-label-group mt-2 mb-3">
												<input
													type="email"
													id="inputEmail"
													className="form-control mobile-form-control login-styling mobile-login-styling"
													id={alert.message ? 'form-glow' : ''}
													placeholder={constants.MOBILE_EMAIL_ADDRESS}
													name="email_address"
													onChange={this.handleChange}
													required
													aria-describedby="basic-addon2"
												/>
											</div>

											<div className="mobile-form-label-group mt-4">
												<input
													type="password"
													id="inputPassword"
													className="form-control mobile-form-control login-styling mobile-login-styling"
													id={alert.message ? 'form-glow' : ''}
													placeholder="Password"
													name="password"
													onChange={this.handleChange}
													required
												/>
											</div>
											{alert.message && (
												<div
													className={`alert text-center ${alert.type}`}
													id="errorMessage"
													className="error-message"
												>
													{alert.message}
												</div>
											)}
											<div className="button-links">
												<button
													className="btn btn-lg btn-primary btn-block mt-4 mb-0 custom-btn mobile-custom-btn mobile-custom-btn-style"
													onClick={this.handleSubmit}
													type="submit"
												>
													{constants.SIGN_IN}
												</button>
																								<br />
												
											</div>
										</form>
										
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
				<Footer />
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const authstate = state.auth;
	const { whitelabel } = state.whitelabel;

	return {
		alert,
		authstate,
		whitelabel,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		getOnBoardingStatus: (onboardingLoginEmail) => {
			dispatch(authActions.getOnBoardingStatus(onboardingLoginEmail));
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		loginAuthentication: (email_address, password) => {
			dispatch(authActions.login(email_address, password));
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
		appVersion : () => dispatch(AppVersionActions.fetchAppVersion())
	};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogIn));



// WEBPACK FOOTER //
// ./src/screens/LogIn/index.js